import {createSelector} from 'reselect';
import get from 'lodash/get';

const linkSelector = state => state.link;

export const getLinks = createSelector(
  [linkSelector],
  links => get(links, 'links', {})
);
